import {FC, useEffect, useState} from 'react';
import styled from 'styled-components';
import {Tag} from 'antd/lib';
import {ETransactionFilterValues} from '../../../utils/enums';
import {TableParams} from '../../../types';
import {isNotEmptyArray} from '../../../utils/functions';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../../config/store';
import {setTableParams} from '../../../entities/logs';
import {flexMixin, textMixin} from '../../../styles/mixins';

interface IProps {
	total: number;
	tableParams: TableParams;
}
const FilterTransactionInfo: FC<IProps> = ({total, tableParams}) => {
	const [filterTags, setFilterTags] = useState<string[]>([]);
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		const {filters} = tableParams;
		let updatedTags: string[] = [];

		if (filters?.sex !== null && filters?.sex)
			updatedTags.push(ETransactionFilterValues.GENDER);
		if (filters?.template !== null && isNotEmptyArray(filters?.template))
			updatedTags.push(ETransactionFilterValues.TEMPLATES);
		if (filters.date !== null && filters.date) updatedTags.push(ETransactionFilterValues.DATE);
		if (filters.payment !== null && filters.payment)
			updatedTags.push(ETransactionFilterValues.PAYED);
		if (filters.hours !== null && filters.hours)
			updatedTags.push(ETransactionFilterValues.HOURS);

		setFilterTags(updatedTags);
	}, [tableParams]);

	const handleClose = (removedTag: string) => {
		const newTags = filterTags.filter((tag) => tag !== removedTag);
		let removed = {};
		switch (removedTag) {
			case ETransactionFilterValues.GENDER:
				removed = {sex: null};
				break;
			case ETransactionFilterValues.DATE:
				removed = {date: null};
				break;
			case ETransactionFilterValues.TEMPLATES:
				removed = {template: null};
				break;
			case ETransactionFilterValues.PAYED:
				removed = {payment: null};
				break;
			case ETransactionFilterValues.HOURS:
				removed = {hours: null};
				break;
			default:
				break;
		}
		const newTableParams = {
			...tableParams,
			filters: {
				...tableParams.filters,
				...removed,
			},
		};

		dispatch(setTableParams(newTableParams));
		setFilterTags(newTags);
	};

	return (
		<FilterInfoWrap>
			<>{`Найдено пользователей: ${total}`}</>
			<InfoWrap>
				{filterTags.length > 0 && <>Активные фильтры:</>}
				{filterTags.map((tag) => (
					<CustomTag
						key={tag}
						closable={true}
						onClose={() => handleClose(tag)}
						color='magenta'
						bordered={false}
					>
						{tag}
					</CustomTag>
				))}
			</InfoWrap>
		</FilterInfoWrap>
	);
};

export default FilterTransactionInfo;

const FilterInfoWrap = styled.div`
	flex-wrap: wrap;
	${flexMixin('row', 'flex-start', 'center')};
	align-items: center;
	${textMixin({
		fontSize: '14px',
		fontWeight: 500,
	})};
	gap: 30px;
`;

const InfoWrap = styled.div`
	${flexMixin('row', 'flex-start', 'center')};
	gap: 3px;
	${textMixin({
		fontSize: '14px',
		fontWeight: 500,
	})};
	& span {
		margin-right: 5px;
	}
`;
const CustomTag = styled(Tag)`
	.ant-tag-close-icon {
		margin-left: 8px;
	}
`;
